import React, {memo} from 'react';
import {Handle, Position} from 'reactflow';

import {Box, IconButton, Stack, Typography} from "@mui/material";
import {IconPlayerPlay} from "@tabler/icons-react";
import {green} from "@mui/material/colors";
import {useSetAtom} from "jotai";
import {ChatDrawerAtom} from "../pages/project/atoms";


function StartNode({id}) {
  const setChatDrawer = useSetAtom(ChatDrawerAtom);

  const onPlay = () => {
    setChatDrawer({
      open: true,
      startNode: id
    })
  }

  return (
    <Box className={"node start-node"}
         sx={{
           width: "60px",
           bgcolor: green[500],
           border: 1,
           pl: 0.5, pr: 2, py: 0.5,
           borderRadius: "8px",
           borderColor: "white",
           boxShadow: 1
         }}
    >
      <Stack direction={"row"} gap={1} alignItems={"center"} sx={{color: "#FFF"}}>
        <IconButton
          onClick={onPlay}
          size={"small"} sx={{borderRadius: "50% !important", color: "inherit"}}
        >
          <IconPlayerPlay size={13}/>
        </IconButton>
        <Typography sx={{fontSize: 9, fontWeight: "bold"}}>Start</Typography>
      </Stack>
      <Handle type="source" position={Position.Right} id={id}/>
    </Box>
  );
}

export default memo(StartNode);